<template>
  <!-- Modal -->
  <b-modal id="depositViaMOMO" centered hide-footer>
    <template #modal-title>
      NẠP QUA MOMO<span v-if="settings.discount_momo > 0"> TẶNG {{
        settings.discount_momo
      }}%</span>
    </template>
    <div class="d-block text-center">
      <p>
        <b class="text-info">VÍ ĐIỆN TỬ:</b> <b class="text-danger">MOMO</b>
        <br/>
        SỐ ĐT: <b class="text-danger">{{ website.momo_number || '0937081199' }} <i @click="copyToClipBoard(website.momo_number)" class="ti-layers"></i
      ></b>
        <br/>
        Chủ TK: <b class="text-danger">{{ website.momo_name || 'SETTING ADMIN' }} <i @click="copyToClipBoard(website.momo_name)" class="ti-layers"></i
      ></b>
        <br/>
      </p>

      <p>
        Nội dung chuyển khoản <sup class="text-warning">(*)</sup>:
        <strong class="text-danger" id="napmomo"
        >{{website.charge_prefix}}{{ user.id ? user.id : '{ID của bạn}' }} <i
            @click="copyToClipBoard(`${website.charge_prefix}${user.id ? user.id : '{Id của bạn}'}`)" class="ti-layers"></i
        ></strong>
        <br />
      </p>

      <p class="deposit-des-txt" v-if="!website.popup_momo_content">
        <strong style="color: blue"
        >Hệ thống nạp tự động, vui lòng kiểm tra kỹ SDT trước khi chuyển
          :</strong
        >
        <br />
        Bước 1: Nhập số điện thoại nhận tiền trên ứng dụng Momo
        <br />
        Bước 2 : Copy chính xác nội dung chuyển tiền để được cộng tiền tự động (viết liền không có dấu cách)
        <br />
        Bước 3: Chờ khoảng 1-2 phút reload lại trang số dư sẽ được cập nhật.
        <br />
        <strong style="color: red">Lưu ý : Nếu ghi sai ID hoặc quá 5 phút chưa nhận tiền vui lòng nhắn
          page góc phải màn hình để được hỗ trợ.</strong>
      </p>
      <p v-else>
        <span v-html="website.popup_momo_content"></span>
      </p>
    </div>
    <!-- <b-button class="mt-3" block @click="$bvModal.hide('depositViaMOMO')">Đóng</b-button> -->
  </b-modal>
</template>

<script>
export default {
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
    settings: {
      Type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    async copyToClipBoard(myText) {
      await navigator.clipboard.writeText(myText);
      this.$swal.fire({
        timer: 1000,
        icon: "info",
        title: "Copy thành công",
        showConfirmButton: false,
        width: '400px',
      });
    },
  }
}
</script>

<style scoped>

</style>
